export default __webpack_public_path__ + "static/nursing_carousel_4-0cf89ae5958f68b6dcdad8b20b678af7.jpg";